// 判断对象的 value 全部为非 undefined | null | '' | NaN 返回 undefined, 否则返回对象本身
export const hasValueObject = <T = object>(obj: T, filterList = [undefined, null, '', NaN]) => {
  return !Object.values(obj).every((v) => filterList.includes(v)) ? obj : undefined;
};
